import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Wordmark } from "@/components/NavigationHeader";
import { API } from "@/config";

const NAV = [
  { label: "How it works", href: "#how" },
  { label: "Results", href: "#results" },
  { label: "FAQ", href: "#faq" },
];

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSending(true);
    try {
      await axios.post(`${API}/leads`, { email, source: "footer-updates" });
      toast.success("You're on the list. We'll be in touch.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <footer className="bg-[#E9E9EF] py-16 border-t border-[#DEDAEA]" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Wordmark />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#6B5CA5]">
              The specialized B2B growth partner for IT recruitment firms.
              Personalized LinkedIn outreach and cold email that turn into qualified sales meetings.
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#7A6F94] font-semibold">Navigate</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-[#3B0764] hover:text-violet-700 transition-colors duration-300">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#7A6F94] font-semibold">Occasional outbound insights</p>
            <p className="mt-5 text-sm text-[#6B5CA5]">Short, practical notes on winning clients as a recruitment firm. No spam.</p>
            <form onSubmit={submit} className="mt-5 flex gap-2" data-testid="footer-email-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@yourfirm.com"
                data-testid="footer-email-input"
                className="w-full rounded-full border border-[#F0EBF8] bg-[#FFFFFF] px-5 py-3 text-sm text-[#3B0764] placeholder:text-[#9C92B5] outline-none transition-colors duration-300 focus:border-violet-500"
              />
              <button
                type="submit"
                disabled={sending}
                data-testid="footer-email-submit"
                className="shrink-0 inline-flex items-center gap-2 rounded-full bg-violet-700 px-5 py-3 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:bg-violet-600 hover:scale-[1.03] disabled:opacity-60"
              >
                {sending ? "..." : <ArrowRight className="h-4 w-4" />}
              </button>
            </form>
          </div>
        </div>
        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-[#DEDAEA] pt-8">
          <p className="text-xs text-[#7A6F94]">© {new Date().getFullYear()} GrowRx. Built for IT recruitment firms.</p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#9C92B5]">Outbound · Pipeline · Meetings</p>
        </div>
      </div>
    </footer>
  );
};
